<template>
  <el-dialog id="SampleDetail" title="检验详情" :visible.sync="visible">
    <el-row>
      <el-col :span="24">
        <p>基础信息</p>
      </el-col>
    </el-row>
    <el-row class="content">
      <!--<el-row>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">医院条形码：{{data.hospCode}}</span>
        </el-col>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">检验条形码：{{data.snCode}}</span>
        </el-col>
      </el-row>-->
      <el-row>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">用户姓名：{{data.patientName}}</span>
        </el-col>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">
            用户性别：<template v-for="item in options_patientSex">
              <template v-if="data.patientSex == item.value">{{item.label}}
              </template>
            </template>
          </span>
        </el-col>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">出生日期：{{data.patientBirthday.substring(0,10)}}</span>
        </el-col>
        <!--<el-col :span="12">
          <span class="info">病区：{{data.bingqu}}</span>
        </el-col>
      </el-row>


      <el-row>
        <el-col :span="12">
          <span class="info">床号：{{data.chuanghao}}</span>
        </el-col>
        <el-col :span="12">
          <span class="info">送检科室：{{data.keshi}}</span>
        </el-col>-->
      </el-row>
    </el-row>
    <el-row>
      <el-col :span="24">
        <p>检验信息</p>
      </el-col>
    </el-row>
    <el-row class="content">

        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">检验项目：{{data.itemName}}</span>
        </el-col>
        <!--<el-col :span="12">
          <span class="must">*</span>
          <span class="info">样本数量：{{data.sampleNum}}</span>
        </el-col>-->

        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">样本类型：{{data.sampleType}}</span>
        </el-col>
        <!--<el-col :span="12">
          <span class="must">*</span>
          <span class="info">样本性状：{{data.sampleProperties}}</span>
        </el-col>-->

      <!--<el-row>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">采集时间：{{data.submitTime}}</span>
        </el-col>
        <el-col :span="12">
          <span class="must">*</span>
          <span class="info">送检检验所：{{data.providerName}}</span>
        </el-col>
      </el-row>-->
      <!--<el-row>
        <el-col :span="24">
          <span class="must">*</span>
          <span class="info">
            报告方式：
           <template v-for="item in options_reportMode">
            <template v-if="data.reportMode == item.value">
              {{item.label}}
            </template>
          </template>
          </span>
        </el-col>
      </el-row>-->
      <!--<el-row>
        <el-col :span="24">
          <span class="info">备注：{{data.remark}}</span>
        </el-col>
      </el-row>-->

      <el-col :span="24">
        <span class="info">
          标本状态：<template v-for="item in options_status">
            <template v-if="data.status == item.value">{{item.label}}
            </template>
          </template>
        </span>
      </el-col>

      <el-col :span="24">
        <span class="info">
          检验结果：<template v-for="item in options_result">
          <template v-if="data.result == item.value">{{item.label}}
          </template>
        </template>
        </span>
      </el-col>

      <!--<el-col :span="24">
        <span class="info">审核状态：{{data.reportStatus}}</span>
      </el-col>-->
    </el-row>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import { getCookie } from "../util/util";

  export default {
    name: "sample-detail",
    data() {
      return {
        visible: false,
        data:{},
        //性别
        options_patientSex: [{
          value: '0',
          label: '女'
        }, {
          value: '1',
          label: '男'
        }],
        //检验状态
        options_status: [{
          value: '1',
          label: '待送检'
        }, {
          value: '2',
          label: '待检验'
        }, {
          value: '3',
          label: '检验完成'
        },
          {
            value: '4',
            label: '待回收'
          }, {
            value: '9',
            label: '拒收'
          }

        ],
        //检验结果
        options_result: [{
          value: '-1',
          label: '暂无'
        }, {
          value: '0',
          label: '阴性'
        }, {
          value: '1',
          label: '阳性'
        }],
        //报告方式
        options_reportMode: [{
          value: '0',
          label: '电子'
        }, {
          value: '1',
          label: '纸质'
        }]
      }
    },
    methods: {
      init (id) {
        axios.get("/jys/sample/hospInfo/" + id, {
          headers: {
            "Content-Type": "application/json",
            "token": getCookie("_token") ? getCookie("_token") : ""
          }
        })
        .then(res => {
          if(res.data.code == 0){
            this.data = res.data.sample
            this.visible = true
          }
        });
      }
    }
  }
</script>

<style scoped>
  #SampleDetail >>> .el-dialog__header{
    text-align: center;
  }
  #SampleDetail >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
  }
  #SampleDetail >>> .el-dialog__body{
    padding: 20px 5%;
    color: #000000;
  }
  .must{
    color: #DA434A;
    position: absolute;
  }
  .info{
    margin-left: 15px;
  }
  .content{
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-detail.vue